import React from "react";

import {
  SingleLine as Input,
  SINGLELINE_SIZES
} from "@widgets/inputs/index.jsx";

export function SingleLine(props) {
  return <Input {...props} size={SINGLELINE_SIZES.MEDIUM} />;
}
